import loadScript from '@/helpers/loadScript'
import { VK_OPENAPI_SRC } from '../config'

let loadingPromise: Promise<void> | null = null

export function loadVkOpenApi() {
  if (window.VK) {
    return Promise.resolve()
  }

  if (!loadingPromise) {
    loadingPromise = new Promise<void>((resolve, reject) => {
      const script = loadScript(VK_OPENAPI_SRC)

      script.addEventListener('load', () => resolve())
      script.addEventListener('error', () => {
        script.remove()
        loadingPromise = null
        reject(new Error(`Failed to load ${VK_OPENAPI_SRC}`))
      })
    })
  }

  return loadingPromise
}
